export default "__VITE_ASSET__zyF5ryJu__"